import DOMPurify from 'dompurify';

export type Rule = {
  maxLength: { value: number; message: string };
};

export const plainTextLengthValidator = (attributes: Rule) => (value: string) => {
  const plainText = DOMPurify.sanitize(value, { ALLOWED_TAGS: [] });
  return plainText.length <= attributes.maxLength.value || attributes?.maxLength.message;
};
